// ----- Imports ----- //
import { getLocale } from '@guardian/libs';
import * as abTest from 'helpers/abTests/abtest';
import { Country } from 'helpers/internationalisation/classes/country';
import { CountryGroup } from 'helpers/internationalisation/classes/countryGroup';
import { analyticsInitialisation, consentInitialisation, sendConsentToOphan, } from 'helpers/page/analyticsAndConsent';
import { getReferrerAcquisitionData } from 'helpers/tracking/acquisitions';
async function setUpConsent() {
    const countryId = Country.detect();
    // Initialize CMP first
    try {
        const localeCode = await getLocale();
        const country = localeCode ?? countryId;
        // Initialise the consent management platform using the getLocale result
        // If getLocale fails to determine a location, fall back to the country detected by the country module
        consentInitialisation(country);
    }
    catch (e) {
        console.log(`An exception was thrown getting the localeCode: ${String(e)}`);
        consentInitialisation(countryId);
    }
    return sendConsentToOphan();
}
function setUpTracking(participations) {
    console.log({ participations });
    const acquisitionData = getReferrerAcquisitionData();
    analyticsInitialisation(participations, acquisitionData);
}
function setUpTrackingAndConsents(participations) {
    void setUpConsent();
    setUpTracking(participations);
}
function getAbParticipations() {
    const countryId = Country.detect();
    const countryGroupId = CountryGroup.detect();
    const abtestInitalizerData = {
        countryId,
        countryGroupId,
    };
    const participations = abTest.init(abtestInitalizerData);
    return {
        ...participations,
    };
}
// ----- Exports ----- //
export { getAbParticipations, setUpConsent, setUpTracking, setUpTrackingAndConsents, };
